import { AppLink } from "../../configs/constants";
import { ROUTE } from "../../routes";
import { generateUniqueId } from "../../configs/utils";
export const onClosePopup = async (action, _datastore, { hidePopup, asyncStorage, navigate }) => {
    console.warn('**** onClosePopup Action Triggered ****', action);
    await hidePopup();
};
export const onShareLink = async (action, _datastore, standardUtilities) => {
    console.warn('**** onShareLink Action Triggered ****', action);
    const user = action?.payload.value;
    console.log("User 123: ", user);
    const phoneNumber = user.borrowerAccountProfile.phoneNumber ? user.borrowerAccountProfile.phoneNumber : '';
    const link = `${AppLink}?user=${phoneNumber.slice(3)}`;
    if (user) {
        standardUtilities.navigate(ROUTE.INVITE_CLIENT, {
            _link: link,
            _removeBanner: true,
            _title: 'Directly share the Volt Money app link with your customers.'
        });
    }
};
export const onTrackCustomerJourney = async (action, _datastore, standardUtilities) => {
    console.warn('**** onTrackCustomerJourney leads Action Triggered ****', action.payload.value);
    const user = action.payload.value;
    const trackingId = await generateUniqueId();
    await standardUtilities.instrumentTrack("PLJ_LOAD_INITIATED", {
        trackingId: trackingId
    });
    const borrowerAccountId = user?.creditApplication.accountId;
    await standardUtilities.navigate(ROUTE.VOLT_APP, { borrowerAccountId: borrowerAccountId, name: user?.borrowerAccountProfile?.name, userDetails: user });
};
